const pdfjsLib = (window as { [key: string]: any })['pdfjs-dist/build/pdf'] as any;

// pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js';

export default pdfjsLib;
